import React from 'react';

import { salesforceUtils } from 'shared/utils';
import { createStylesHook } from 'shared/hooks';
import i18next from 'core/i18n';
import { LinkButton } from '@indigo-ag/component-module';

const useStyles = createStylesHook(() => ({
  content: {
    fontWeight: 'bold'
  }
}));

interface Props {
  id: string;
}

export const GenericSalesforceLink: React.FunctionComponent<Props> = ({ id }: Props): JSX.Element => {
  const link = salesforceUtils.getGenericURL(id);

  const classes = useStyles();

  return (
    <LinkButton to={link} target="_blank" className={classes.content}>
      {i18next.t('seeOnSalesforce')}
    </LinkButton>
  );
};
